import { devLogger } from "@/utils/dev-logger.util";
export const RssListingAccordion = (element) => {
    const toggleButton = element.querySelector('[data-rss-listing-accordion-toggle]');
    const contentContainer = element.querySelector('[data-rss-listing-accordion-content]');
    const chevronIcon = element.querySelector('[data-rss-listing-accordion-chevron]');
    if (!toggleButton || !contentContainer || !chevronIcon) {
        devLogger.warn("RssListingAccordion: Required elements not found");
        return;
    }
    // Read initial state from HTML (aria-expanded attribute)
    // CSHTML always sets aria-expanded="false" for collapsed state
    const initialExpanded = toggleButton.getAttribute("aria-expanded") === "true";
    let isExpanded = initialExpanded;
    const updateAccordionState = (expanded) => {
        isExpanded = expanded;
        if (expanded) {
            // Expand: show content, rotate chevron down
            contentContainer.classList.remove("hidden");
            contentContainer.setAttribute("aria-hidden", "false");
            chevronIcon.classList.remove("rotate-45");
            chevronIcon.classList.add("-rotate-135");
            toggleButton.setAttribute("aria-expanded", "true");
        }
        else {
            // Collapse: hide content, rotate chevron right
            contentContainer.classList.add("hidden");
            contentContainer.setAttribute("aria-hidden", "true");
            chevronIcon.classList.remove("-rotate-135");
            chevronIcon.classList.add("rotate-45");
            toggleButton.setAttribute("aria-expanded", "false");
        }
    };
    const toggleAccordion = (event) => {
        event.preventDefault();
        event.stopPropagation();
        updateAccordionState(!isExpanded);
    };
    const handleKeydown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleAccordion(event);
        }
    };
    if (!contentContainer.id) {
        contentContainer.id = `rss-accordion-content-${Math.random().toString(36).substr(2, 9)}`;
    }
    toggleButton.setAttribute("role", "button");
    toggleButton.setAttribute("aria-controls", contentContainer.id);
    // Initialize accordion state - ensure TS takes full control
    // CSHTML provides initial collapsed state, TS manages all state changes
    updateAccordionState(initialExpanded);
    toggleButton.addEventListener("click", toggleAccordion);
    toggleButton.addEventListener("keydown", handleKeydown);
    return () => {
        toggleButton.removeEventListener("click", toggleAccordion);
        toggleButton.removeEventListener("keydown", handleKeydown);
    };
};
